<template>
  <!-- zoomInLeft   zoomOutRight -->
  <transition
    enter-active-class="animated bounceIn"
    leave-active-class="animated bounceOut"
  >
    <div
      :class="[
        'dial-box',
        argotDialresData.isDrawed === '0' ||
        (!argotDialresData.watchword &&
          !argotDialresData.integral &&
          argotDialresData.isDrawed === '1')
          ? 'dial-bg1'
          : 'dial-bg2'
      ]"
      @touchmove.pervent
      v-if="argotDialShow"
    >
      <yxvzb-canvas
        v-if="argotDialresData.isDrawed === '0'"
        @getValue="getValue"
        @canvasClose="canvasClose"
      ></yxvzb-canvas>
      <transition enter-active-class="animated rubberBand">
        <div
          class="hb"
          v-if="argotDialresData.watchword || argotDialresData.integral"
        >
          <img
            src="http://cdn.yxvzb.com/WEB/wx-master/images/anyu/c.png"
            alt=""
            class="close"
            @click="close"
          />
          <p class="p1" v-if="argotDialresData.watchword">暗 语</p>
          <div class="content">
            <p :class="['p2', argotDialresData.watchword ? 'p2w' : '']">
              {{
                argotDialresData.watchword ||
                  '获得' + argotDialresData.integral + '积分'
              }}
            </p>
            <p
              class="p3"
              v-html="
                argotDialresData.watchword
                  ? '公众号回复暗语即可领奖'
                  : '积分可以到<br />积分商城兑换礼品'
              "
            ></p>
          </div>
        </div>
      </transition>
      <div
        class="no-div"
        v-if="
          !argotDialresData.watchword &&
            !argotDialresData.integral &&
            argotDialresData.isDrawed === '1'
        "
      >
        <p class="p1">抽奖结果</p>
        <p class="p2">今天没有抽到奖品，明天再来吧。</p>
        <p class="p3" @click="close">确定</p>
      </div>
    </div>
  </transition>
</template>

<script>
import yxvzbCanvas from './canvas.vue';
export default {
  props: {
    argotDialShow: {
      type: Boolean,
      default: false
    },
    showType: {
      type: Number,
      default: 1 // 1 转盘  2 暗语 3 积分 4 下次
    },
    argotDialresData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    yxvzbCanvas
  },
  data() {
    return {
      zpVaule: -1
    };
  },
  methods: {
    close() {
      this.$emit('update:argotDialShow', false);
    },
    getValue(value) {
      this.$emit('update:argotDialresData', value);
    },
    canvasClose() {
      this.close();
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.dial-bg1 {
  background: rgba(0, 0, 0, 0.3);
}
.dial-bg2 {
  background-image: url('http://cdn.yxvzb.com/WEB/wx-master/images/anyu/bgg.png');
  background-size: 100% 100%;
}
.dial-box {
  width: 100%;
  height: 100%;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  .no-div {
    position: absolute;

    width: 7.4667rem /* 560/75 */;
    height: 3.88rem /* 291/75 */;
    border-radius: 0.1067rem /* 8/75 */;
    background: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%;);
    padding-top: 0.6667rem /* 50/75 */;
    padding-bottom: 0.3333rem /* 25/75 */;
    text-align: center;
    .p1 {
      font-size: 0.48rem /* 36/75 */;

      font-weight: bold;
      margin-bottom: 0.24rem /* 18/75 */;
    }
    .p2 {
      font-size: 0.4rem /* 30/75 */;
      color: #4a4a4a;
      margin-bottom: 0.4rem /* 30/75 */;
    }
    .p3 {
      border-top: 1px solid #d2d3d5;
      font-size: 0.48rem /* 36/75 */;
      padding-top: 0.3333rem /* 25/75 */;
      font-weight: bold;
      line-height: 1;
    }
  }
  .hb {
    width: 100%;
    height: 8rem;
    position: absolute;
    background-image: url('http://cdn.yxvzb.com/WEB/wx-master/images/anyu/tc.png');
    background-size: 100% 100%;
    top: 25%;
    .close {
      width: 0.64rem /* 48/75 */;
      height: 0.64rem /* 48/75 */;
      position: absolute;
      right: 1.5rem;
      top: 0.7rem;
    }
    .p1 {
      position: absolute;
      font-size: 0.6rem;
      width: 0.6rem;
      left: 2.5rem;
      top: 3rem;
      font-weight: bold;
    }
    .content {
      width: 4.3067rem /* 323/75 */;
      height: 3.28rem /* 246/75 */;
      position: absolute;
      top: 2.5rem;
      left: 3.8rem;
      text-align: center;
      padding-top: 0.01rem;
      font-weight: bold;
      .p2 {
        font-size: 0.6rem /* 72/75 */;
        color: #d80022;
        line-height: 1;
        margin-top: 0.8rem /* 60/75 */;
      }
      .p2w {
        font-size: 0.5rem !important;
      }
      .p3 {
        font-size: 0.32rem /* 24/75 */;
        letter-spacing: -0.83px;
        margin-top: 0.4rem /* 30/75 */;
      }
    }
  }
}
</style>
